"use client";

import { useEffect, useRef } from "react";

import {
  CALENDAR_DAY_BUTTON_CLASS_MAP,
  type TCalendarDayButtonProps,
} from "@/ui/components/form/Calendar/Calendar.config";
import { cn } from "@/ui/lib/utils";

export const CalendarDayButton = ({
  className,
  day,
  modifiers,
  ...props
}: TCalendarDayButtonProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (modifiers.focused) {
      buttonRef.current?.focus();
    }
  }, [ modifiers.focused ]);

  return (
    <button
      {...props}
      ref={buttonRef}
      data-component="CalendarDayButton"
      data-day={day.isoDate}
      data-selected-single={
        modifiers.selected
        && !modifiers.range_start
        && !modifiers.range_end
        && !modifiers.range_middle
      }
      data-range-start={modifiers.range_start}
      data-range-middle={modifiers.range_middle}
      data-range-end={modifiers.range_end}
      data-today={modifiers.today}
      data-outside={modifiers.outside}
      className={cn(
        CALENDAR_DAY_BUTTON_CLASS_MAP.base,
        CALENDAR_DAY_BUTTON_CLASS_MAP.selectedSingle,
        CALENDAR_DAY_BUTTON_CLASS_MAP.rangeStart,
        CALENDAR_DAY_BUTTON_CLASS_MAP.rangeMiddle,
        CALENDAR_DAY_BUTTON_CLASS_MAP.rangeEnd,
        CALENDAR_DAY_BUTTON_CLASS_MAP.today,
        CALENDAR_DAY_BUTTON_CLASS_MAP.outside,
        CALENDAR_DAY_BUTTON_CLASS_MAP.disabled,
        className,
      )}
    />
  );
};

CalendarDayButton.displayName = "CalendarDayButton";
